import { useCallback, useState } from 'react';

import { STR } from '../../../../i18n';
import { ApiError, exportAccessWorkbook } from '../../../../lib/api';
import { showToast } from '../../../../lib/toast';

function saveFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 4000);
}

/** The Matrix header action downloads the complete, server-built and audited workbook. */
export function useWorkbookExport(): { label: string; onClick: () => void } {
  const [exporting, setExporting] = useState(false);

  const run = useCallback(async (): Promise<void> => {
    setExporting(true);
    try {
      const { blob, filename } = await exportAccessWorkbook();
      saveFile(blob, filename);
      showToast(STR.access.matrix.exportComplete);
    } catch (error) {
      showToast(
        error instanceof ApiError ? error.message : STR.access.matrix.exportFailed,
        'warn',
      );
    } finally {
      setExporting(false);
    }
  }, []);

  return {
    label: exporting ? STR.access.matrix.exportingWorkbook : STR.access.matrix.exportWorkbook,
    onClick: () => {
      if (!exporting) void run();
    },
  };
}
